<template>
  <div class="container">
    <div class="header">{{contact.first_name}}</div>
    <nav class="add-navigation">
      <div @click="$router.push({name: 'reseller-users-list'})" class="back-link">
        <svg class="icon" width="30px" height="30px" viewBox="0 0 30 30" version="1.1">
          <path
            d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
            id="path-1"
          />
        </svg>
        <p>Back to Users</p>
      </div>
      <div class="buttons-wrapper">
        <div @click="$router.push({name: 'reseller-users-list'})" class="secondary-button">
          <secondary-button>Cancel</secondary-button>
        </div>
        <div class="primary-button">
          <primary-button @click.native="editUser">Save User</primary-button>
        </div>
      </div>
    </nav>
    <div class="add-container">
      <span class="container-title">Edit User</span>
      <div class="col-wrapper">
        <div class="col" v-if="contact">
          <primary-input
            type="text"
            name="first name"
            v-model="contact.first_name"
            @input="handleFirstName"
            v-validate="'required'"
            :class="{'input': true, 'is-danger': errors.has('first name')}"
            placeholder="Enter first name"
          />
          <div
            class="help is-danger"
            v-if="errors.has('first name')"
          >{{ errors.first('first name') }}</div>
          <primary-input
            type="text"
            name="user name"
            v-model="contact.user_name"
            v-validate="'required'"
            :class="{'input': true, 'is-danger': errors.has('user name')}"
            placeholder="Enter username"
          />
          <div class="help is-danger" v-if="errors.has('user name')">{{ errors.first('user name') }}</div>
          <primary-input
            type="password"
            name="password"
            v-model="contact.passwd"
            @input="handlePassordChange"
            v-validate="'required'"
            ref="password"
            :class="{'input': true, 'is-danger': errors.has('first name')}"
            placeholder="********"
          />
          <div v-if="errors.has('password')" class="help is-danger">{{ errors.first('password') }}</div>

          <primary-select
            type="text"
            name="active"
            v-model="contact.is_active"
            v-validate="'required'"
            :class="{'input': true, 'is-danger': errors.has('active')}"
            placeholder="Choose active"
          >
            <option value="true" :selected="contact.is_active">Active</option>
            <option value="false" :selected="!contact.is_active">Inactive</option>
          </primary-select>
          <div v-if="errors.has('active')" class="help is-danger">{{ errors.first('active') }}</div>
        </div>
        <div class="col" v-if="contact">
          <primary-input
            type="text"
            name="last name"
            v-model="contact.last_name"
            @input="handleLastName"
            v-validate="'required'"
            :class="{'input': true, 'is-danger': errors.has('first name')}"
            placeholder="Enter last name"
          />
          <div v-if="errors.has('last name')" class="help is-danger">{{ errors.first('last name') }}</div>
          <primary-input
            name="email"
            type="text"
            v-model="contact.email"
            v-validate="'required'"
            :class="{'input': true, 'is-danger': errors.has('first name')}"
            placeholder="Enter email"
          />
          <div v-if="errors.has('email')" class="help is-danger">{{ errors.first('email') }}</div>
          <primary-input
            type="password"
            name="re-enter password"
            v-validate="'required|confirmed:password'"
            data-vv-as="password"
            v-model="checkPassowrd"
            :class="{'input': true, 'is-danger': errors.has('first name')}"
            placeholder="********"
          />
          <div
            class="help is-danger"
            v-if="errors.has('re-enter password')"
          >{{ errors.first('re-enter password') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    EditDropzone: () => import("@/components/EditDropzone"),
  },
  data: () => ({
    role: ["Admin", "User"],
    rank: {
      Premium: "Admin",
      Default: "User",
    },
    contact: null,
    user: {
      user_name: null,
      email: null,
      last_name: null,
      passwd: null,
      first_name: null,
      rank: null,
    },
    file: null,
    checkPassowrd: null,
    changedPassword: null,
    companyList: [],
  }),
  created() {
    // this.getAllCompanies();
    this.getUser();
  },
  methods: {
    // getAllCompanies() {
    //   this.$store.dispatch("GetCompanyList").then(res => {
    //     console.log("sdsd", res);
    //     this.companyList = res.items;
    //     this.getUser();
    //   });
    // },
    handleFirstName(v) {
      this.contact.first_name = this.$capitalize(v);
    },
    handleLastName(v) {
      this.contact.last_name = this.$capitalize(v);
    },
    handlePassordChange(value) {
      this.contact.passwd = value;
      this.changedPassword = value;
    },
    getUser() {
      this.$store
        .dispatch("GetUser", {
          id: this.$route.params.id,
        })
        .then((res) => {
          console.log("res ->>>", res);
          this.contact = res;
          this.contact.rank = this.rank[res.rank];
          this.checkPassowrd = this.contact.passwd;
          // this.GetFile();
        });
    },
    // GetFile() {
    //   if (!this.contact.logo_file_uuid) {
    //     return;
    //   }

    //   var mockFile = { size: 1024, name: "Userlogo", type: "image/png" };
    //   this.$refs.userEditDropzone.$el.dropzone.emit("addedfile", mockFile);
    //   this.$refs.userEditDropzone.$el.dropzone.emit(
    //     "thumbnail",
    //     mockFile,
    //     `http://88.198.219.62/api_smsc/v1/file/${this.contact.logo_file_uuid}`
    //   );
    //   this.$refs.userEditDropzone.$el.dropzone.emit("complete", mockFile);
    // },
    // fileAdded(file) {
    //   if (file.accepted) {
    //     this.file = file;
    //   }
    // },
    // fileRemoved() {
    //   this.file = null;
    //   this.user.logo_file_uuid = null;
    // },
    // uploadPhoto: async function () {
    //   let data = new FormData();

    //   data.append("file", this.file);
    //   data.append("belongs_to", "user.logo");
    //   data.append("public", true);

    //   return await this.$store.dispatch("UploadFile", data);
    // },
    editUser: async function () {
      const valid = await this.$validator.validate();

      if (!valid) {
        return;
      }

      try {
        // if (this.file) {
        //   let res = await this.uploadPhoto();
        //   this.user.logo_file_uuid = res.object_uuid;
        // }

        const rank = {
          Admin: "Premium",
          User: "Default",
        };
        this.user.user_name = this.contact.user_name;
        this.user.email = this.contact.email;
        this.user.last_name = this.contact.last_name;
        this.user.first_name = this.contact.first_name;
        this.user.rank = rank[this.contact.rank];
        // this.user.rank = "s";
        this.user.passwd = this.contact.passwd;
        this.user.is_active = this.contact.is_active;

        if (this.changedPassword) {
          this.user.passwd = this.changedPassword;
        } else {
          delete this.user.passwd;
        }

        await this.$store.dispatch("EditUser", {
          id: this.$route.params.id,
          contact: this.user,
        });

        this.$success("User credentials have beed edited.");

        this.$router.push({ name: "reseller-users-list" });
      } catch (err) {
        this.$error(err);
      }
    },
  },
};
</script>

<style lang="scss" >
.input {
  width: 95%;
}
.container {
  font-family: "Helvetica Neue";
  padding: 0 20px;

  .header {
    padding: 15px 0;
    font-size: 16px;
    color: #666;
  }
  .add-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    width: 100%;
    margin-bottom: 20px;
    .back-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      p {
        margin-bottom: 0;
      }
    }

    .buttons-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;
      .primary-button {
        height: 40px;
        width: 130px;
      }
      .secondary-button {
        height: 40px;
        width: 90px;
        margin-right: 20px;
      }
    }
  }
  .add-container {
    flex-direction: column;
    align-items: center;
    height: fit-content;
    background-color: #ffffff;
    padding-top: 15px;
    .container-title {
      height: 30px;
      width: 432px;
      color: #000000;
      font-size: 16px;
      font-weight: 500;
      line-height: 30px;
      padding: 15px 0 15px 15px;
    }
    .col-wrapper {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-left: 15px;
      margin-top: 20px;
      .col {
        width: 100%;
        padding-right: 15px;
        .input {
          margin-bottom: 20px;
        }
        .pimary-input-title {
          color: #000000;
          font-family: "Helvetica Neue";
          font-size: 12px;
          font-weight: 900;
          letter-spacing: 0.21px;
          line-height: 15px;
          margin-bottom: 5px;
          text-transform: uppercase;
        }
        .dimension,
        #editdropzone {
          min-height: 90px;
          height: 90px;
          width: 90px;
          border-radius: 45px;
          .dz-preview,
          .dz-processing,
          .dz-image-preview,
          .dz-success,
          .dz-complete,
          .dz-complete {
            height: 80px;
            width: 80px;
            border-radius: 50px;
            margin-left: -40px;
            min-height: 80px;
            top: -20px;
          }
          .dz-image {
            padding: 5px;
            img {
              height: 80px;
              width: 80px;
              border-radius: 50px;
            }
          }
          .dz-details {
            height: 80px;
            width: 80px;
            border-radius: 50px;
            .dz-size {
              padding-top: 15px;
              span {
                font-size: 14px;
              }
            }
          }
          a {
            font-size: 10px;
            height: 80px;
            width: 80px;
            border-radius: 50px;
            margin-top: 20px;
            margin-left: 0px;
          }
        }

        .upload-contaioner {
          background-color: #ffffff;
          height: 265px;
          margin-right: 15px;
          display: flex;
          .photo {
            height: 90px;
            width: 90px;
            border: 1px solid #5171f3;
            border-style: dashed;
            border-radius: 45px;
            background-color: #ffffff;
            img {
              height: 80px;
              widows: 80px;
              border-radius: 50px;
              padding: 5px;
            }
          }
          .upload-content {
            display: flex;
            margin: 0 66px 0 15px;
            span {
              margin-top: 10px;
              height: 25px;
              width: 194px;
              color: #55616e;
              font-size: 16px;
              line-height: 20px;
            }
            input[type="file"] {
              position: absolute;
              height: 36px;
              width: 136px;
              opacity: 0;
              cursor: pointer;
              z-index: 1;
              margin-top: 30px;
            }
            // .upload-button {
            //     height: 36px;
            //     width: 136px;
            //     border-radius: 4px;
            //     background-color: #51A3F3;
            //     position: absolute;
            //     margin-top: 30px;
            // }
          }
        }
      }
    }
    .col > div[data-v-2f08c06e] {
      width: 95%;
    }
    .col > div[data-v-01567ff0] {
      width: 95%;
    }
    .email-input {
      margin-bottom: 20px;
    }
    .password-input {
      margin-bottom: 30px;
    }
    .first {
      margin-bottom: 30px;
      .remember-me {
        display: flex;
        align-items: center;
        input {
          margin-right: 5px;
        }
      }
    }
  }
}
</style>

